import axios, { AxiosInstance } from "axios";

export default (token?: string, customHeaders?: Record<string, string>): AxiosInstance => {
  const headers = { ...customHeaders };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers,
    withCredentials: true,
  });
};
